import { useBunja } from 'bunja/react';
import { useSetAtom } from 'jotai';

import { FeedPostEditForm } from '@flipster/features/src/shared/community-feed/post-and-edit/form';
import { Styles } from '@flipster/styled-system/css';

import { communityFeedBunja } from '../bunja';

export const FeedPost = ({ css }: { css?: Styles }) => {
  const { symbol, communityFeedTabAtom } = useBunja(communityFeedBunja);
  const setCommunityFeedTab = useSetAtom(communityFeedTabAtom);
  if (!symbol) return null;
  return <FeedPostEditForm submitLabel='Post' css={css} onComplete={() => setCommunityFeedTab('POST')} />;
};
